<template>
    <div v-if="body_show">
    </div>
</template>

<script>
    import { coursedetail } from "@/api/course"
    import { isMain } from "@/utils/tools"
    export default {
        data(){
            return{
                bid: "",
                body_show: false
            }
        },
        methods:{
            pullData(){
                this.bid = this.$route.query.bid;
				coursedetail({bid: this.bid})
					.then((data) => {
                        if(isMain() && data.id<=4){
                            location.href = "https://api.xjy.cn/tools/career/course/course_details.html?bid=1";
                            return;
                        }
                        this.body_show = true;
                        // let url = data.judge == 'detailB'?'./details_new?bid=' + this.bid:'./details_old?bid=' + this.bid;
                        // this.$router.push(url);
                        let router = data.judge == 'detailB' ? 'details_new' : 'details_old';
                        if(data.ishavedbuy) {
                            router = 'details_old'
                        }
                        let url = location.href;
                        location.href = url.replace('course_details', router);
					})

			}
        },
		created(){
            this.pullData();
		}
    }
</script>

<style lang="scss" scoped>


</style>
